// extracted by mini-css-extract-plugin
export default {"input":"AddCredit-input_EojEo","spinner":"AddCredit-spinner_r71Op","icon":"AddCredit-icon_RDPDI","discount":"AddCredit-discount_ULzlS"};